import firebase from 'firebase'
const config = {
  apiKey: "AIzaSyBJGHaB1ckKv-qpQ6Rq1CXNr6-o5v-gIWw",
  authDomain: "yahtzee.hildobijl.com",
  databaseURL: "https://yahtzee-175021.firebaseio.com",
  projectId: "yahtzee-175021",
  storageBucket: "",
  messagingSenderId: "153013001184"
}
firebase.initializeApp(config)
export default firebase



// WEBPACK FOOTER //
// ./src/config/firebase.js